<template>
  <td>
    <template v-if="loading">
      Loading...
    </template>
    <div class="d-flex justify-center" v-else>
      <template
        v-for="(segment, index) in segments[level][build.map_id][build.build_id][platform][category.title]"
      >
        <div :key="segment.number" :style="{ borderColor: segment.color }" class="segment-marker mr-1">
          <router-link
            class="font-weight-bold"
            :to="{
              path: '/map',
              query: {
                tab: 'runtime',
                activeCategories: [category.category],
                map_id: build.map_id,
                map_name: level,
                map_type: 0,
                [category.category + '_platform']: platform,
                [category.category + '_prevPlatform']: platform,
                [category.category + '_build']:  build.build_id,
                [category.category + '_prevBuild']:  build.build_id,
                [category.category + '_segment']: segment.number
              }
            }"
            target="_blank"
          >
            {{ segment.number }}
          </router-link>
        </div>
        <template v-if="index + 1 < segments[level][build.map_id][build.build_id][platform][category.title].length">
          <div
            class="px-2 d-flex align-center"
            :key="segment.number + '_separator'"
          >
            -
          </div>
        </template>
      </template>
    </div>
  </td>
</template>

<script>
export default {
  name: 'SegmentsColumn',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    level: {
      type: String,
      required: true
    },
    segments: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    build: {
      type: Object,
      required: true
    },
    platform: {
      type: String,
      required: true
    }
  },
}
</script>

<style lang="css" scoped>
.segment-marker {
  padding: 4px;
  border: 3px solid;
  border-radius: 6px;
}
</style>